import type { Valuation } from "./Valuation";
import type { ArtworkMeasurement } from "./ArtworkMeasurement";
export enum ArtistSource {
    System = 1,
    User = 2
}

export interface Artist {
    artistId: number;
    artistName: string;
    countryName: string;
    nationality?: string;
    birthDate?: string;
    deathDate?: string;
    artistPeriod?: string;
    biography?: string;
    source: ArtistSource;
    clientBio?: string;
}

export interface Currency {
    currencyCode: string;
    currencyName: string;
}

export interface ArtworkImage {
    imageId: number;
    imageUrl: string;
    caption?: string;
    isPrimary: boolean;
}

export interface ArtworkImageStub {
    imageId: number;
    imageUrl: string;
    isPrimary?: boolean;
};

export interface ArtworkImages {
    artworkId: number;
    imageUrls: ArtworkImageStub[];
};

export interface Artwork {
    artworkId: number;
    artWorkTitle: string;
    artworkCreationDate?: string;
    artDescription?: string;
    medium?: string;
    estimatedValue: number;
    artistName: string;
    currencyCode: string;
    imageUrls: ArtworkImageStub[];
    currency: Currency;
    categoryName: string;
    categoryId: number;
    locationPath: string;
    locationId: number;
    artist: Artist;
    mainImage?: string;
    images?: ArtworkImage[];
    measurements: ArtworkMeasurement[];
    height: number;
    width: number;
    depth: number;
    dimensionUnits: string;
    weight: number;
    weightUnits: string;
    editionVolume: number;
    editionNumber: number;
    dateAcquired?: Date
    sourceId?: number;
    sourceOrganisationId?: number;
    sourceName?: string;
    sourceDescription?: string;
    provenance?: string;

}

export interface ArtworkStub {
    artworkId: number;
    artWorkTitle: string;
    artworkCreationDate?: string;
    dateAcquired?: string;
    artDescription?: string;
    medium?: string;
    estimatedValue: number;
    artistId: number;
    artistName: string;
    currencyCode: string;
    imageUrls: string[];
    currency: Currency;
    categoryName: string;
    categoryId: number;
    locationPath: string;
    locationId: number;
    imageUrl: string;
    imageCount: number;
    editionVolume: number;
    editionNumber: number;

    acquisitionValuation?: Valuation | null;
    insuranceValuation?: Valuation | null;
    fairMarketValuation?: Valuation | null;

    artworkStatusId?: number;
}

export type ArtworksResponse =
    | { items: ArtworkStub[]; total: number }
    | ArtworkStub[]; 

export interface ArtworkNavigationState {
    source: 'gallery' | 'search' | 'category';
    scrollPosition?: number;
    artworks?: ArtworkStub[];
    currentIndex?: number;
}

export type ArtworkFilterList = {
    artworkIds: number[];
}